import {
  FilmsPaginated,
  MoviesSiteMapResponse,
  Showtimes,
  filmCinemasResponse,
  filmExperiencesResponse,
  movieDetailsResponse,
} from './models';
import { createInfiniteQuery, createMutation, createQuery } from '../../libs';
import { short_term_cashing } from '@/constants/cashing';

export const filmsUrl = 'films';
const urlShowtimes = 'showtimes';
const urlFilmFilters = 'film-filters';

export const useGetMovieDetails = createQuery<
  movieDetailsResponse,
  unknown,
  string,
  {
    cityId: number;
  }
>({
  method: 'get',
  url: `${filmsUrl}/:id`,
});

export const useGetMovieDetailsBySlug = createQuery<
  movieDetailsResponse,
  unknown,
  string
>(
  {
    method: 'get',
    url: `${filmsUrl}/unique-name/:slug`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);

export const useGetMovieCinemas = createQuery<filmCinemasResponse>({
  method: 'get',
  url: `${filmsUrl}/:id/cinemas`,
});

export const useGetMovieCinemasFilter = createQuery<filmCinemasResponse>({
  method: 'get',
  url: `/cinemas/${urlFilmFilters}`,
});

export const useGetMovieExperiencesFilter = createQuery<filmExperiencesResponse>({
  method: 'get',
  url: `/experiences/${urlFilmFilters}`,
});

export const useGetInfiniteMovies = createInfiniteQuery<FilmsPaginated>(
  {
    method: 'get',
    url: `${filmsUrl}`,
  },
  {
    staleTime: short_term_cashing,
    keepPreviousData: false,
  }
);

export const useGetMovies = createQuery<FilmsPaginated>(
  {
    method: 'get',
    url: `${filmsUrl}`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);

export const useGetShowtimes = createQuery<Showtimes>(
  {
    method: 'get',
    url: `${urlShowtimes}/:id`,
  },
  {
    staleTime: short_term_cashing,
    keepPreviousData: false,
  }
);

export const useFilmRemindMe = createMutation({
  method: 'POST',
  url: `${filmsUrl}/:id/:customUrl`,
});

export const useRemoveReminder = createMutation({
  method: 'delete',
  url: `${filmsUrl}/:id/:customUrl`,
});

export const useGetMoviesSiteMap = createQuery<MoviesSiteMapResponse>({
  method: 'get',
  url: `${filmsUrl}/slug`,
});

export const useGetOfferFilms = createInfiniteQuery<
  FilmsPaginated,
  unknown,
  '',
  {
    cityId: number;
    date: string;
    offerId: string;
  }
>({
  url: `${filmsUrl}/offer`,
  method: 'get',
});
